import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// File Saver
import { saveAs } from 'file-saver';

// Notistack
import { useSnackbar } from 'notistack';

// Apollo
import { useMutation } from '@apollo/client';
import { UPLOAD_SIGN_OFF_SHEET } from './gql-upload-sign-off-sheet';

// Services
import { IWorkSituation } from 'services/interfaces';
import { getErrorExtensions, getFileExtension, getFormattedDate } from 'services/utils';
import { API_URL } from 'services/apollo-client';

// Components
import UploadSignOffSheetCard from 'components/upload-sign-off-sheet-card';

// ---------------------------------------------------------------------------------------------------- \\
// ---------------------------------------- SIGN OFF SHEET URL ---------------------------------------- \\
// ---------------------------------------------------------------------------------------------------- \\

export default function SignOffSheetUrl({
    workSituation,
    refetch,
} : {
    workSituation: IWorkSituation | undefined,
    refetch: any,
}) {

    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [uploadSignOffSheet, { loading, error, data }] = useMutation(UPLOAD_SIGN_OFF_SHEET);

    const onChangeFile = (files: FileList | null) => {
        if (files && files.length > 0) {
            uploadSignOffSheet({
                variables: {
                    id: workSituation?.id,
                    file: files[0],
                },
            });
        }
    };

    const onSaveSignOffSheet = () => {
        let fileName = t('work_situation').toUpperCase() + '-' + getFormattedDate(workSituation?.trainingDate);
        saveAs(
            API_URL + workSituation?.signOffSheetUrl,
            fileName + '.' + getFileExtension(workSituation?.signOffSheetUrl),
        );
    };

    useEffect(() => {
        if (data?.uploadWorkSituationSignOffSheet) {
            enqueueSnackbar(t('added_successfully'), { variant: 'success' });
            refetch();
        }
        if (error) {
            enqueueSnackbar(getErrorExtensions(error), { variant: 'error' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, error]);

    return (
        <UploadSignOffSheetCard
            onSaveSignOffSheet={onSaveSignOffSheet}
            onChangeFile={onChangeFile}
            signOffSheetUrl={workSituation?.signOffSheetUrl}
            loading={loading}
        />
    );
}
